/** @file decodeSheet: a bundle sheet PNG decoded by image-io with the web zlib codec (texels as raster's). */
import { decodePng } from '@zilo/pose3d-image-io/png/decodePng';
import type { Image } from '@zilo/pose3d-image-io/types/image';
import { webZlibCodec } from '@zilo/pose3d-image-io/zlib/webZlibCodec';

/**
 * The RGBA8 image of `png` through image-io's `decodePng` and `webZlibCodec` (DecompressionStream): no browser
 * decode, no gamma or premultiplication, so the GPU samples exactly the texels raster samples.
 */
export async function decodeSheet(png: Uint8Array): Promise<Image> {
  return decodePng(png, webZlibCodec);
}
